export const progressNoteGenerator = "/therapy-note";

export const calculatorAndToolsSlugs = {
  toolbox: "/toolbox",
  goodFaithEstimateCalculator: () => "/toolbox/good-faith-estimate-generator",
  therapistDeductionsCalculator: () => "/toolbox/therapist-deductions-calculator",
  sessionFeeCalculator: () => "/toolbox/session-fee-calculator",
  outOfNetworkCalculator: () => "/toolbox/out-of-network-calculator",
  // paperworkAndFormGenerator: () => "/private-practice-paperwork-library",
  paperworkAndFormGenerator: () => "/practice-paperwork",
  therapyNotesGenerator: () => "/therapy-note",
  superbillGenerator: () => "/super-bill",
};

export const oldCalculatorAndToolsSlugs = {
  goodFaithEstimateCalculator: () => "/toolbox/good-faith-estimate-calculator",
  therapistDeductionsCalculator: () => "/toolbox/optimize-calculator",
  sessionFeeCalculator: () => "/toolbox/session-fee-calculator",
  outOfNetworkCalculator: () => "/toolbox/out-of-network-calculator",
  paperworkAndFormGenerator: () => "/practice-paperwork",
  therapyNotesGenerator: () => "/therapy-note",
};

export const calculatorAndToolsName = {
  toolbox: "Toolbox",
  goodFaithEstimateCalculatorName: () => "Good Faith Estimate Generator",
  therapistDeductionsCalculatorName: () => "Therapist Deductions Calculator",
  sessionFeeCalculatorName: () => "Therapy Session Fee Calculator",
  outOfNetworkCalculatorName: () => "Out-Of-Network Reimbursement Calculator",
  therapyNotesGeneratorName: () => "Clarity Notes - Progress Note Generator",
  paperworkAndFormGeneratorName: () => "Private Practice Form Library + Generator",
  superbillGenerator: () => "Superbill Generator",
};

export const singleCalculatorsSlugs = {
  goodFaithEstimateCalculator: () => "/good-faith-estimate-generator",
  therapistDeductionsCalculator: () => "/therapist-deductions-calculator",
  sessionFeeCalculator: () => "/therapy-session-fee-calculator",
  outOfNetworkCalculator: () => "/out-of-network-reimbursement-calculator",
};

// export const calculatorAndToolsResoucesLandingSlugs = {
//   goodFaithEstimateCalculator: () => "/resources/63/practice-in-good-faith-a-no-surprises-act-gfe-calculator-for-therapists",
//   therapistDeductionsCalculator: () => "/resources/66/optimize-your-deductions-a-complete-expense-tracker-and-calculator-for-therapists",
//   sessionFeeCalculator: () => "/resources/59/private-practice-fee-calculator",
//   outOfNetworkCalculator: () => "/resources/60/out-of-network-insurance-calculator",
//   paperworkAndFormGenerator: () => "/resources/69/private-practice-paperwork-library-and-form-builder-for-mental-health-professionals-in-private-practice",
//   therapyNotesGenerator: () => "/resources/67/therapy-note-generator",
//   superbillGenerator: () => "/resources/75/what-is-a-superbill-for-therapy-and-why-do-i-need-one",
// };

export const calculatorAndToolsResoucesLandingSlugs = {
  goodFaithEstimateCalculator: () => "/good-faith-estimate-generator",
  therapistDeductionsCalculator: () => "/therapist-deductions-calculator",
  sessionFeeCalculator: () => "/therapy-session-fee-calculator",
  outOfNetworkCalculator: () => "/out-of-network-reimbursement-calculator",
  paperworkAndFormGenerator: () => "/private-practice-paperwork-library",
  therapyNotesGenerator: () => "/clarity-notes-progress-notes-generator",
  superbillGenerator: () => "/superbill-generator",
};

export const headerSlugs = {
  dashboard: "/dashboard",
  myAccount: "/my-account",
  therapistInformation: "/my-account?scrollto=Therapist-Information",
  businessInformation: "/my-account?scrollto=business-information",
  mySubscription: "/my-account?scrollto=subscription",
  myPayments: "/my-account?scrollto=Payment",
  myAccountSettings: "/my-account?scrollto=Settings",
  library: "/library",
  resource: "/resources",
  blog: "/blog",
  marketPlace: "/market-place",
  insurance: "/insurance",
  healthInsurance: "/insurance/health-insurance",
  dentalInsurance: "/insurance/dental-insurance",
  visionInsurance: "/insurance/vision-insurance",
  memberBenefits: "/member-benefits",
  community: "/community",
  communityExploreForum: "https://community.claritycooperative.com/topics",
  communityAttendLiveSession: "https://community.claritycooperative.com/events",
  communityJoinGroups: "https://community.claritycooperative.com/all-groups",
  communityConnectNetwork: "https://community.claritycooperative.com/feed",
  communityMeetMembers: "https://community.claritycooperative.com/members",
  myPatients: "/client-detail/page/1",
  support: "/support",
  help: "/help",
  videoTutorial: "/video-tutorials",
  about: "/about",
  reportAProblem: "/report-a-problem",
  requestAFeature: "/request-a-feature",
  inviteFriend: "/dashboard?inviteFriend=true",
  login: "/login",
};

export const headerTitle = {
  dashboard: "Dashboard",
  myAccount: "My Account",
  therapistInformation: "Member Information",
  businessInformation: "Business Information",
  mySubscription: "My Subscription",
  myPayments: "Payment",
  myAccountSettings: "Settings",
  library: "Library",
  resource: "Resources",
  blog: "Blog",
  marketPlace: "Market Place",
  insurance: "Insurance",
  healthInsurance: "Health Insurance",
  dentalInsurance: "Dental Insurance",
  visionInsurance: "Vision Insurance",
  memberBenefits: "Exclusive Discounts",
  community: "Community",
  communityExploreForum: "Explore Forum",
  communityAttendLiveSession: "Attend Live Sessions",
  communityJoinGroups: "Join groups",
  communityConnectNetwork: "Connect + Network",
  communityMeetMembers: "Meet Members",
  myPatients: "My Patients",
  support: "Support",
  help: "Help",
  videoTutorial: "Video Tutorials",
  reportAProblem: "Report a Problem",
  requestAFeature: "Request a Feature",
  inviteFriend: "Invite Friends",
  notification: "Notifications",
  about: "About",
};

export const repo = {
  next: "Next",
  react: "React",
};

export const practiceSlugs = {
  root: "/practice-paperwork",
  practiceUrl: () => "/practice-paperwork/form",
  addTemplate: () => "/practice-paperwork/form/" + uuid(),
  previewTemplate: (formId) => `/practice-paperwork/preview/${formId}`,
  editTemplate: (formId) => `/practice-paperwork/form/${formId}`,
  categoryFormPage: (formsType, category) => `/practice-paperwork/${formsType}/${category}`,
  categoryPage: (formsType, category, page = "1") => `/practice-paperwork/${formsType}/${category}/${page}`,
};
